import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Box,
  Typography,
  Alert,
} from '@mui/material';
import {
  Close,
  Save,
} from '@mui/icons-material';
import * as Actions from 'actions';

const ContactListDialog = (props) => {
  const {
    open,
    onClose,
    createContactList,
    reqStatus,
  } = props;

  const [name, setName] = useState('');
  const [description, setDescription] = useState('');
  const [namePattern, setNamePattern] = useState('');
  const [showSuccess, setShowSuccess] = useState(false);

  useEffect(() => {
    if (reqStatus === 'SELLER_CREATE_CONTACT_LIST_SUCCESS') {
      setShowSuccess(true);
      // Auto close after 1.5 seconds
      setTimeout(() => {
        handleClose();
      }, 1500);
    }
  }, [reqStatus]);

  const handleClose = () => {
    setName('');
    setDescription('');
    setNamePattern('');
    setShowSuccess(false);
    onClose();
  };

  const handleSave = () => {
    if (!name.trim()) {
      alert('Please enter a list name');
      return;
    }

    const listData = {
      name: name.trim(),
      description: description.trim(),
    };

    // If name pattern is provided, add filter criteria
    if (namePattern.trim()) {
      listData.filter_criteria = {
        name_pattern: namePattern.trim(),
      };
    }

    createContactList(listData);
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle>
        <Box display="flex" alignItems="center" justifyContent="space-between">
          <Typography variant="h6">Create Contact List</Typography>
          <Button
            onClick={handleClose}
            color="inherit"
            size="small"
          >
            <Close />
          </Button>
        </Box>
      </DialogTitle>
      
      <DialogContent>
        {showSuccess && (
          <Alert severity="success" sx={{ mb: 2 }}>
            Contact list created successfully!
          </Alert>
        )}

        <TextField
          fullWidth
          label="List Name"
          placeholder="e.g., VIP Customers, Weekly Newsletter"
          value={name}
          onChange={(e) => setName(e.target.value)}
          margin="normal"
          required
          helperText="Give your contact list a descriptive name"
        />

        <TextField
          fullWidth
          label="Description"
          placeholder="Describe this contact list..."
          value={description}
          onChange={(e) => setDescription(e.target.value)}
          margin="normal"
          multiline
          rows={2}
          helperText="Optional description for your reference"
        />

        <TextField
          fullWidth
          label="Name Filter (Optional)"
          placeholder="e.g., John, Premium, ^A (starts with A)"
          value={namePattern}
          onChange={(e) => setNamePattern(e.target.value)}
          margin="normal"
          helperText="Filter contacts by name pattern (supports regex)"
        />

        <Box sx={{ mt: 2 }}>
          <Alert severity="info">
            <Typography variant="body2">
              <strong>Tips:</strong>
            </Typography>
            <Typography variant="body2" component="div">
              • Leave name filter empty to manually add contacts later
              <br />
              • Use simple text like "John" to match all names containing "John"
              <br />
              • Use regex like "^A" to match names starting with "A"
              <br />
              • You can add more contacts to this list later
            </Typography>
          </Alert>
        </Box>
      </DialogContent>

      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button onClick={handleClose}>
          Cancel
        </Button>
        <Button
          variant="contained"
          onClick={handleSave}
          disabled={!name.trim()}
          startIcon={<Save />}
        >
          Create List
        </Button>
      </DialogActions>
    </Dialog>
  );
};

const _ContactListDialog = connect(
  ({ sellerContacts }) => ({
    reqStatus: sellerContacts.reqStatus,
  }),
  (dispatch) =>
    bindActionCreators(
      {
        createContactList: Actions.createContactList,
      },
      dispatch
    )
)(ContactListDialog);

export default _ContactListDialog;

